// extracted by mini-css-extract-plugin
export default {"productCarousel":"fj","twoColumns":"gj","subhed":"hj","promo":"ij","questionIcon":"jj","thumbContainer":"kj","carousel":"lj","tape":"mj","flexContainer":"nj","nav":"oj","body":"pj","reviews":"qj","header":"rj","hed":"sj","priceContainer":"tj","oldPrice":"uj","newPrice":"vj","infoTabs":"wj","tabs":"xj","text":"yj","questionWrapper":"zj","isQuantity":"Aj","title":"Bj","titleRight":"Cj","addToCart":"Ej","servingsPerItem":"Fj","quantityInput":"Gj","quantityButton":"Hj","takeTheQuiz":"Ij"};
    if(module.hot) {
      // 1713361640527
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  